import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  type DialogProps,
  DialogTitle,
} from '@shared/components';

export type ConfirmPrintExaminationCodeLoadingModalProps = Pick<DialogProps, 'open'> & {
  onClose: () => void;
  handleSubmit: () => void;
};

export default function ConfirmPrintExaminationCodeLoadingModal(
  props: Readonly<ConfirmPrintExaminationCodeLoadingModalProps>,
) {
  const { open: isOpen, onClose, handleSubmit } = props;
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth='xs'>
      <DialogTitle onClose={onClose}>ยืนยันการดาวน์โหลดใบแจ้งรหัสสอบ</DialogTitle>
      <DialogContent>
        คุณแน่ใจว่าจะดาวน์โหลดใบแจ้งรหัสสอบโดยที่
        <strong> &quot;ไม่มีเลขที่นั่งสอบ&quot;</strong>
      </DialogContent>
      <DialogActions>
        <Button size='large' variant='outlined' color='secondary' onClick={onClose}>
          ยกเลิก
        </Button>
        <Button size='large' variant='contained' color='primary' onClick={handleSubmit}>
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
}
